import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {filter, first, takeUntil, tap} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {SubmissionsService} from "../../shared/services/submissions.service";
import {FileInput} from "ngx-material-file-input";
import {ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../../shared/interface/response/counted-and-paginated";
import {Submissions} from "../../shared/interface/submissions";

interface Request {
  value: string;
  viewValue: string;
}

interface Reporting {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-submissions',
  templateUrl: './submissions.component.html',
  styleUrls: ['./submissions.component.scss']
})
export class SubmissionsComponent implements OnInit {

  submissionsForm: FormGroup;
  titleControl: FormControl;
  requestTypeControl: FormControl;
  reportingModuleControl: FormControl;
  registrationsViewControl: FormControl;
  contentsControl: FormControl;
  priorityControl: FormControl;
  fileControl: FormControl;
  contentControl: FormControl;
  typeControl: FormControl;
  items: Submissions[] = [];
  reportings:  Reporting[] =  [];
  totalData = 0;
  addMode = false;
  module= true;

  displayedColumns: string[] = [
      'custom_id', 'title', 'email',  'status', 'attachment',
  ];
  expandedElement: Submissions = null;
  modify = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  requests: Request[] = [
    {value: '850f9280-b496-480c-b205-de68423415dc', viewValue: 'Błąd w programie'},
    {value: 'eb04437e-662a-48c7-9b8e-dde5865551e5', viewValue: 'Nowe funkcjonalności'},
    {value: 'cf3b065f-4a60-4ee4-8163-74310d364f65', viewValue: 'Zmiany obecnych funkcjonalności'},
  ];

  type: Request[] = [
    {value: '2df74737-3caf-45bc-9ee3-dd31e06ecb42', viewValue: 'ASF24'},
    {value: 'da2e9b65-a451-4333-8a2c-70604babb27f', viewValue: 'ASF360'},
    {value: '9e6a277f-8fa7-421e-85dd-bfd1d8a6f65e', viewValue: 'Chronię.pl'},
    {value: '774d3b04-6d72-47f2-8921-eda1789eed30', viewValue: 'DobryAgent.pl'},
    {value: '13cc0b74-20fe-4cce-ac0e-b1e481989e8d', viewValue: 'Hiperio'},
  ];

  reportings24: Reporting[] = [
    {value: '8e2f8404-8040-4194-a625-f028f5bd9583', viewValue: 'Struktura Sieci'},
    {value: 'ce406ec5-bd4e-4351-85eb-e4b802a30dd0', viewValue: 'Rejestracje'},
    {value: '73827f55-c8e6-4200-a7d5-2a1a321194bc', viewValue: 'Rozliczenia'},
    {value: '435020eb-2a7b-44b8-b816-2a47e9967495', viewValue: 'Administracja'},
    {value: '4303b32e-586d-417d-80b1-2feba73803ce', viewValue: 'Globalne'},
  ];
  reportings360: Reporting[] = [
    {value: '443531c6-06be-48cb-b01a-6edbb329ff8f', viewValue: 'Posty'},
    {value: '8415d5dd-b766-46dd-9ee1-81e85847f19f', viewValue: 'Pracownicy'},
    {value: '7a43b4f6-9eae-4485-8018-a980312cf56d', viewValue: 'Umowy'},
    {value: '4303b32e-586d-417d-80b1-2feba73803ce', viewValue: 'Globalne'},
    {value: '73827f55-c8e6-4200-a7d5-2a1a321194bc', viewValue: 'Rozliczenia'},

  ];
  constructor(
    public dialogRef: MatDialogRef<SubmissionsComponent>,
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private submissionsService: SubmissionsService,

  ) {
    this.submissionsService.submissionsListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<Submissions>) => {
          this.items = e.items;
        })
      ).subscribe();
    this.submissionsForm = fb.group({
      title: this.titleControl = fb.control('', [Validators.required]),
      requestType: this.requestTypeControl = fb.control('', [Validators.required]),
      reportingModule: this.reportingModuleControl = fb.control('', [Validators.required]),
      contents: this.contentsControl = fb.control('', [Validators.required]),
      priority: this.priorityControl = fb.control('', [Validators.required]),
      type: this.typeControl = fb.control('', [Validators.required]),
      file: this.fileControl = fb.control('', ),
      filename: fb.control('', ),
      content: this.contentControl = fb.control(''),
      row: fb.control(false, ),
      registrationsView: this.registrationsViewControl = fb.control(true, ),
    });
  }

  ngOnInit(): void {
    this.submissionsForm.get('registrationsView').valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe(() => {
      this.loadListData();
    });

    this.submissionsForm.get('file').valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: FileInput) => !!file)
      )
      .subscribe((file: FileInput) => {

        this.fileControl.value.forEach((fileToRead: File) => {
          this.submissionsForm.get('filename').setValue(fileToRead.name);
          this.submissionsForm.get('content').reset('');
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            this.submissionsForm.get('content').setValue(
              this.submissionsForm.get('content').value +
              (this.submissionsForm.get('content').value ? ', ' : '') +
              (/base64,(.+)/.exec(reader.result.toString())[1])
            );
          };
        });
      });

    this.typeControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(val => {
        this.reportingModuleControl.reset();

        const isSpecificId = val === '2df74737-3caf-45bc-9ee3-dd31e06ecb42';
        const isDisabledId = [
          '9e6a277f-8fa7-421e-85dd-bfd1d8a6f65e',
          '774d3b04-6d72-47f2-8921-eda1789eed30',
          '13cc0b74-20fe-4cce-ac0e-b1e481989e8d'
        ].includes(val);

        this.module = isSpecificId || !isDisabledId;
        this.reportings = isSpecificId || isDisabledId ? this.reportings24 : this.reportings360;

        if (isDisabledId) {
          this.reportingModuleControl.disable();
        } else {
          this.reportingModuleControl.enable();
        }
      });


  }

  ngAfterViewInit(): void {
    this.loadListData();
  }
  loadListData(): void {
    if (this.registrationsViewControl.value){
      this.submissionsService.loadList(0);
    }else {
      this.submissionsService.loadArchivesList(0);
    }
  }
  addModeActive(): void {
    this.addMode = true;
    this.loadListData();
  }

  addFile(id): void{

  }

  expend_more(element): void{
    element.row = true;
  }
  expend_less(element): void{
    element.row = false;
  }

  addModeDisabled(): void {
    this.addMode = false;
    this.loadListData();

  }
  sendForm(): void {
    if (!this.submissionsForm.valid) {
      this.submissionsForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.submissionsService.send(this.submissionsForm.getRawValue())
      .subscribe(() => {
        this.snack.open('Zgłoszenie zostało dodane ', '', {duration: 2000});
        this.addMode = false;
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy dodawaniu zgłoszenia wystąpił błąd', error.status.toString(), {duration: 2000});
      });
     this.titleControl.reset();
     this.requestTypeControl.reset();
     this.reportingModuleControl.reset();
     this.contentsControl.reset();
     this.priorityControl.reset();
    this.typeControl.reset();
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
